/* Éclora sur Horizon — ajout au panier pour les sections ecl-*.
   Envoie /cart/add.js, met à jour le tiroir natif d'Horizon (événement cart:update, rendu de section) puis l'ouvre.
   <ecl-product-form> : enveloppe un formulaire produit standard et l'envoie par EclCart.add. */
(function () {
  if (window.EclCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) < 0) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function add(payload) {
    var ids = sectionIds(), opts;
    if (payload instanceof FormData) {
      if (ids.length) { payload.append('sections', ids.join(',')); payload.append('sections_url', location.pathname); }
      opts = { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: payload };
    } else {
      var body = { items: payload.items };
      if (ids.length) { body.sections = ids.join(','); body.sections_url = location.pathname; }
      opts = { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) };
    }
    return fetch(root + 'cart/add.js', opts)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Error');
        return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, sourceId: 'ecl-cart', data: { source: 'ecl-cart', itemCount: cart.item_count, sections: res.j.sections || {} } }
            }));
            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && typeof drawer.open === 'function') {
              if (!drawer.hasAttribute('auto-open')) drawer.open();
            } else {
              location.href = root + 'cart';
            }
            return cart;
          });
      });
  }

  window.EclCart = { add: add };

  if (!customElements.get('ecl-product-form')) {
    customElements.define('ecl-product-form', class extends HTMLElement {
      connectedCallback() {
        var form = this.querySelector('form');
        if (!form || form.dataset.eclBound) return;
        form.dataset.eclBound = '1';
        var wrap = this.querySelector('.product-form__error-message-wrapper');
        var msg = this.querySelector('.product-form__error-message');
        form.addEventListener('submit', function (e) {
          if (e.defaultPrevented) return;
          e.preventDefault();
          var btn = form.querySelector('[type="submit"]');
          if (btn && btn.disabled) return;
          if (btn) { btn.disabled = true; btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true'); }
          if (wrap) wrap.hidden = true;
          add(new FormData(form))
            .catch(function (err) {
              if (msg) msg.textContent = err.message;
              if (wrap) wrap.hidden = false;
            })
            .then(function () {
              if (btn) { btn.disabled = false; btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); }
            });
        });
      }
    });
  }
})();
